<template>
  <Modal
    v-model="visible"
    title="详情"
    footer-hide
    :width="700"
  >
    <Spin fix v-if="loading" />
    <template v-else>
      <div class="item">
        <label>查档单号：</label>
        <div>{{ item.SubscribeNo }}</div>
      </div>
      <div class="item">
        <label>移动电话：</label>
        <div>{{ item.Phone }}</div>
      </div>
      <div class="item">
        <label>邮箱：</label>
        <div>{{ item.EMail }}</div>
      </div>
      <div class="item" v-if="item.SubscribeZQDate">
        <label>预约日期：</label>
        <div>{{ `${item.SubscribeZQDate || ''} ${formatDay(item.Amorpm) || '' }` }}</div>
      </div>
      <div class="item">
        <label>查档工程：</label>
        <div class="link">
          <p
            v-for="(e, i) in data"
            :key="e.SID"
            @click="handleToLink(e)"
          >{{ `${i + 1}、${e.ENG_NAME}` }}</p>
        </div>
      </div>
      <div class="item">
        <label>查档内容：</label>
        <div>
          <p v-for="(q, i) in item.QueryContent" :key="i">{{ `${i + 1}、${q}` }}</p>
        </div>
      </div>
      <div class="item">
        <label>审核状态：</label>
        <div>{{ formatCensorState(item.AcceptStatus) }}</div>
      </div>
      <div class="item" v-if="item.AcceptStatus !== '-1'">
        <label>回复内容：</label>
        <div>{{ item.AcceptStatusNoMessage }}</div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { formatCensorState, formatDay } from '@libs/enum'
import { GetEngineersByCondi } from '@api'
export default {
  name: 'record-reply',
  data () {
    return {
      visible: false,
      loading: false,
      item: {},
      data: [],
      formatCensorState,
      formatDay
    }
  },
  methods: {
    open (item) {
      this.visible = true
      this.item = { ...item }
      this.item.QueryContent = this.item.QueryContent.split('|')
      this.getEng()
    },
    async getEng () {
      this.loading = true
      try {
        const { ArchiveIDS } = this.item
        const { data } = await GetEngineersByCondi({ ArchiveIDS })
        this.data = data
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    handleToLink ({ SID }) {
      this.$router.push({
        name: 'information',
        query: {
          id: SID,
          file: this.item.FileIDS
        }
      })
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
.item {
  display: flex;
  margin-bottom: 8px;
  line-height: 30px;
  label {
    width: 80px;
    text-align: right;
    font-weight: bold;
  }
  div {
    flex: 1;
  }
  .link {
    p {
      color: $default;
      cursor: pointer;
      &:hover {
        font-weight: bold;
      }
    }
  }
}
</style>